import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

type UserDataType = {
  [x: string]: string | number
}

export default function useClientSessionStorage() {
  const [userData, setUserData] = useState<UserDataType>()

  const USER_BASIC_DETAILS = 'user_basic_details'

  useEffect(() => {
    if (typeof window !== 'undefined') {
      let userDetails = {}
      const getUserDataFromSS = sessionStorage.getItem(USER_BASIC_DETAILS)
      if (getUserDataFromSS) {
        userDetails = JSON.parse(getUserDataFromSS)
      } else {
        userDetails = {
          ...userDetails,
          sessionId: uuidv4(),
        }

        sessionStorage.setItem(USER_BASIC_DETAILS, JSON.stringify(userDetails))
      }
      setUserData(userDetails)
    }
  }, [])

  const setUserId = (userId: number) => {
    if (typeof window !== 'undefined') {
      const getUserDataFromSS = sessionStorage.getItem(USER_BASIC_DETAILS)
      let userData = {}
      if (getUserDataFromSS) {
        userData = JSON.parse(getUserDataFromSS)
        userData = {
          ...userData,
          userId,
        }
      }
      setUserData(userData)
      sessionStorage.setItem(USER_BASIC_DETAILS, JSON.stringify(userData))
    }
  }

  return { setUserId, userData: userData as UserDataType }
}
